// extracted by mini-css-extract-plugin
export default {"root":"EmptyMessage__root--6m2BHB","left":"EmptyMessage__left--q2Pcsb"};